'use client'

import { Chip, Stack } from '@mui/material'
import { useTranslations } from 'next-intl'

/** General starter questions for the assistant empty state — not billing-composer prompts. */
export const EMPTY_STATE_SUGGESTION_KEYS = ['suggestionChargers', 'suggestionPermissions', 'suggestionSessions'] as const

type AssistantEmptySuggestionsProps = {
  onSelect: (text: string) => void
}

export default function AssistantEmptySuggestions({ onSelect }: AssistantEmptySuggestionsProps) {
  const t = useTranslations('features.AssistantBar')

  return (
    <Stack
      direction="row"
      spacing={0.75}
      useFlexGap
      flexWrap="wrap"
      justifyContent="center"
      sx={{ mt: 0.5 }}
      data-cy="assistant-suggestions"
    >
      {EMPTY_STATE_SUGGESTION_KEYS.map((key) => (
        <Chip
          key={key}
          label={t(key)}
          size="small"
          variant="outlined"
          onClick={() => onSelect(t(key))}
          sx={{ height: 'auto', py: 0.25, '& .MuiChip-label': { whiteSpace: 'normal' } }}
        />
      ))}
    </Stack>
  )
}
